import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import {
  FormikInput,
  FormikSwitch,
  FormikSingleFileUpload,
} from "../../../../components/formik-components";
import { respEnum, ImageFolderEnum } from "../../../../constants/appConstant";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {
  name: "",
  colorcode: "",
  icon: "",
  isactive: true,
};

const formikValidation = yup.object({
  name: yup.string().required("Bank Name is required"),
  colorcode: yup.string().required("Color Code is required"),
});

const AddBank = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  const onSubmitData = async (d, action) => {
    // Handle icon upload if files are selected
    if (d.files && d.files.filter((item) => !item.imageUrl).length) {
      var uploadFilePathType = ImageFolderEnum.upload;
      d.icon = (
        await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
      )[0].photo;
      d.files = null;
    } else if (d.attachment) {
      d.icon = d.attachment;
    }

    let data = {
      ...d,
      id,
    };
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateBank",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/banks", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    let response = await Common.ApiService.getInstance().request(
      `GetBanks?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      formikRef.current.setValues(response.data[0]);
    }
  };

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent
          ref={dialogRef}
          className="max-h-[100vh] overflow-y-auto sm:max-w-[500px]"
        >
          <DialogHeader>
            <DialogTitle className="text-base font-medium">
              {!id ? "Add" : "Update"} Bank
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500 space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="flex flex-col gap-4">
                  <FormikInput
                    formikProps={formikProps}
                    name={"name"}
                    label={"Bank Name"}
                    placeholder={"Enter Bank Name"}
                  />

                  <FormikInput
                    formikProps={formikProps}
                    name={"colorcode"}
                    label={"Color Code"}
                    placeholder={"Enter Color Code (e.g., #FF5733)"}
                    type={"color"}
                  />

                  <FormikSingleFileUpload
                    formikProps={formikProps}
                    uploadMainTxt={"Upload Bank Icon"}
                    uploadTxt={"Max size 2mb (Optional)"}
                    name={"icon"}
                  />

                  <FormikSwitch
                    formikProps={formikProps}
                    name={"isactive"}
                    label={"Active"}
                  />
                </div>
              )}
            </Formik>
          </div>

          <DialogFooter className="mt-6">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>
            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddBank;
